type ReviewCountSource = {
  reviewsCount?: number | string | null
  reviews_count?: number | string | null
  reviews?: unknown[] | null
}

// Published written reviews plus approved video-only reviews.
// `reviews.length` is only the written list loaded on the page.
export function getPublicReviewCount(
  practice?: ReviewCountSource | null,
  fallbackReviews?: unknown[] | null
): number {
  const explicit = practice?.reviewsCount ?? practice?.reviews_count
  if (explicit !== undefined && explicit !== null && explicit !== "") {
    const count = Number(explicit)
    if (!Number.isNaN(count)) return count
  }

  const reviews = fallbackReviews ?? practice?.reviews
  return Array.isArray(reviews) ? reviews.length : 0
}
